import * as Yup from 'yup';
import {PlatformIntl} from './PlatformIntl.js';

const intl = PlatformIntl.getInstance();

Yup.setLocale({
    mixed: {
        required: ({label}) => {
            if (label) {
                return `${label} ${intl.formatMessage('error_required_field')}`;
            }
            return `${intl.formatMessage('error_this_field')} ${intl.formatMessage('error_required_field')}`;
        },
        notType: `${intl.formatMessage('error_invalid_type')} \${type}`,
    },
    array: {
        min: ({label}) => {
            if (label) {
                return `${label} ${intl.formatMessage('error_required_field')}`;
            }
            return `${intl.formatMessage('error_this_field')} ${intl.formatMessage('error_required_field')}`;
        },
    },
});

export default Yup;
